import { AxiosInstance } from "axios";
import { apiTypeUrlBaseGet } from "../api_common";
import { API_APP_NAMES, API_TYPES } from "../api_constants";
import { authorizationObDefault, axiosInstanceCreate } from "./axios_common";
import { axiosInstance401Handle } from "./axios_intercepter_common";

const citajteoUrlBase: string = apiTypeUrlBaseGet(API_TYPES.CITAJTEO);

export const citajteoAuth = authorizationObDefault();

const API_CITAJTEO_RETRY_LIMIT: number = 3;

export const axiosCitajteo: AxiosInstance = axiosInstanceCreate(
  citajteoUrlBase,
  { withCredentials: true }
);

axiosCitajteo.interceptors.response.use(null, async (err) => {
  if (typeof err.config.retryLimit === "undefined") {
    err.config.retryLimit = API_CITAJTEO_RETRY_LIMIT;
  }
  if (err.config.retryLimit === 0) {
    throw err;
  }
  err.config.retryLimit--;
  if (err.response.status === 401) {
    try {
      await axiosInstance401Handle(
        axiosCitajteo,
        API_APP_NAMES.CITAJTEO,
        citajteoAuth
      );
    } catch (err) {
      throw err;
    }
  }
  const response = await axiosCitajteo(err.config);
  return response;
});
